module.exports = __webpack_public_path__ + "img/ctrl-cross-resonance-stub-up--.536764ff.svg";